import { ApiInterceptor } from "./api.interceptor";

export const PermissionService = { 
    async getPermissions(userId: string | number){
        const response = await ApiInterceptor<IPermission[]>(`/client/permissions/${userId}`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
            },
        });
        return response
    },

    async updatePermission(id:number, field: string, value: boolean){
        const response = await ApiInterceptor<ApiResponse>(`/api/permission_detaileds/${id}`, {
            method: 'PATCH',
            body: JSON.stringify({[field]:value})
        });
        console.log('response',response)
        return response
    },

    async createPermission(user: IUser, text: string, color:string, obj:IPermission){
        const response = await ApiInterceptor<ApiResponse>(`/client/permissions`, {
            method: 'POST',
            body: JSON.stringify({user, text,color, obj})
        });
        console.log('as',{user, text,color, obj})
        return response
    },

    async getCompanyUsers(userExtId:string,userId:number){
        const response = await ApiInterceptor<IUser[]>(`/client/employer/${userExtId}/${userId}`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
            },
        });
        return response
    },

    async createUser(fullName: string, phone: string, areas: string[],userExtId:string, selectedPermission? : number){
        const response = await ApiInterceptor<ApiResponse>(`/client/createUser/${userExtId}`, {
            method: 'POST',
            body: JSON.stringify({fullName,phone,areas,selectedPermission})
        });
        return response
    },

    async updateUser(fullName: string, phone: string, areas: string[],userId:string|number, permission: IPermission | null){
        const response = await ApiInterceptor<ApiResponse>(`/client/updateUser/${userId}`, {
            method: 'POST',
            body: JSON.stringify({fullName,areas,permission,phone})
        });
        return response
    },

    async unpublishUser(userId:string|number){
        const response = await ApiInterceptor<ApiResponse>(`/client/unpublishUser/${userId}`, {
            method: 'PATCH',
        });
        return response
    },

    async createFreeField(keyword: string, valueword: string, userId: string | number){
        const response = await ApiInterceptor<ApiResponse>(`/client/createFreeField/${userId}`, {
            method: 'POST',
            body: JSON.stringify({keyword,valueword})
        });
        return response
    },

    async deletePermission(id:number): Promise<any>{
        const res = await ApiInterceptor<ApiResponse>(`/api/permission_mains/${id}`, {
            method: 'DELETE',
        });
        return res
    },

    async updateMainPermission({ id, permissionDetaileds,isEditable,  ...rest }:IPermission){
        
        const response = await ApiInterceptor<ApiResponse>(`/api/permission_mains/${id}`, {
            method: 'PATCH',
            body: JSON.stringify(rest)
        });
        return response
    }
}